import { log } from 'log';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { STACK } from './constants';
import * as Types from './types';

export const createNoticeTimer = (request: Types.TServerSendRequest, timeout: number) => {
    return setTimeout(() => {
        publicEventsAPIService
            .trigger('socket-notice', {
                requestId: request.ID
            });

        log('oapiNotice', {
            description: 'Request takes longer than usual',
            request
        });

        log('oapiInfo', [
            `The above notice occurred because OpenAPI did not reply to Portal within ${timeout / 1000} seconds.`,
            'In case this is not expected, please raise an issue with OpenAPI team.'
        ].join('\n'));
    }, timeout);
};

export const clearStackEntryTimeouts = (stackEntry: Types.ISocketStackEntry) => {
    clearTimeout(stackEntry.noticeTimer);
    clearTimeout(stackEntry.timer);
};

export const removeStackEntry = (stackEntry: Types.ISocketStackEntry) => {
    const index = STACK.findIndex((item) => item.timer === stackEntry.timer);

    if (index > -1) {
        STACK.splice(index, 1);
    }
};

export const addStackEntry = (stackEntry: Types.ISocketStackEntry) => {
    STACK.unshift(stackEntry);
};

export const createTimeoutTimer = (
    getStackEntry: () => Types.ISocketStackEntry,
    reject: (reason?: any) => void,
    request: Types.TServerSendRequest,
    timeout: number
) => {
    return setTimeout(() => {
        const stackEntry = getStackEntry();

        clearStackEntryTimeouts(stackEntry);
        removeStackEntry(stackEntry);

        reject({
            reason: 'Request timed out',
            request,
            response: {
                ID: -1,
                data: {
                    customError: 'playtech.mobile.system.systemError'
                }
            }
        });
    }, timeout);
};

export const createAbortHandler = (
    stackEntry: Types.ISocketStackEntry,
    signal: AbortSignal,
    request: Types.TServerSendRequest,
    reject: (reason?: any) => void
) => {
    signal.addEventListener('abort', () => {
        clearStackEntryTimeouts(stackEntry);
        removeStackEntry(stackEntry);

        reject({
            reason: 'Request aborted',
            request,
            response: {
                ID: -1,
                data: {
                    customError: 'playtech.mobile.system.systemError'
                }
            }
        });
    });

};

